import { Record } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, unit_type, lambda_type, bool_type, list_type, obj_type, option_type, class_type, string_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Model_$reflection } from "./Types.fs.js";
import { contains, exists, isEmpty } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { stringHash } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";

export class menuItemDefinition extends Record {
    constructor(Title, Icon, Role, Page, Subitems, IsActive, OnClick) {
        super();
        this.Title = Title;
        this.Icon = Icon;
        this.Role = Role;
        this.Page = Page;
        this.Subitems = Subitems;
        this.IsActive = IsActive;
        this.OnClick = OnClick;
    }
}

export function menuItemDefinition_$reflection() {
    return record_type("MenuDef.menuItemDefinition", [], menuItemDefinition, () => [["Title", string_type], ["Icon", option_type(class_type("Fable.React.ReactElement"))], ["Role", string_type], ["Page", obj_type], ["Subitems", list_type(menuItemDefinition_$reflection())], ["IsActive", lambda_type(Model_$reflection(), bool_type)], ["OnClick", option_type(lambda_type(unit_type, unit_type))]]);
}

export function menuItemDefinition__isVisible_7F866359(def, roles) {
    const matchValue = def.Role;
    const matchValue_1 = def.Subitems;
    if (matchValue === "") {
        if (isEmpty(matchValue_1)) {
            return true;
        }
        else {
            return exists((s) => menuItemDefinition__isVisible_7F866359(s, roles), matchValue_1);
        }
    }
    else {
        return contains(matchValue, roles, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        });
    }
}

//# sourceMappingURL=MenuDef.fs.js.map
